// src/components/AIChatWidget.jsx
// Floating 💬 button that opens the AI Assistant page. Shown only when the shop has the ai_chat
// add-on (off by default — the platform owner switches it on). The old n8n chat was replaced by
// the assistant in pages/ai/Assistant.jsx (same one as the desktop app).
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useAddons from '../hooks/useAddons';

export default function AIChatWidget() {
  const addons = useAddons();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  if (!addons.ai_chat || pathname.startsWith('/assistant') || pathname.startsWith('/pos')) return null;
  return (
    <button onClick={() => navigate('/assistant')} title="AI Assistant"
      style={{ position: 'fixed', bottom: 22, right: 22, zIndex: 900, width: 56, height: 56, borderRadius: '50%', border: 'none',
               background: '#2e9f86', color: '#fff', fontSize: 26, cursor: 'pointer', boxShadow: '0 6px 18px rgba(0,0,0,.18)' }}>
      💬
    </button>
  );
}
